module.exports = __webpack_public_path__ + "static/media/tuatj.34fd9733.png";